import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { GroupDetail } from '~/features/GroupDetail';

export const Screen: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return null;
  }

  return (
    <Suspense fallback={<Loader />}>
      <GroupDetail id={Number(id)} />
    </Suspense>
  );
};
